module.exports = __webpack_public_path__ + "static/media/AnandSoni.f89bc6f7.png";